<template>
  <div class="active-subs-layout">
    <Sidebar />

    <div class="main-content">
      <TopHeader pageTitle="Active Subscriptions" />

      <main class="page-content">
        <div class="active-subs-view">

          <!-- Hero Header -->
          <div class="hero">
            <div class="hero-left">
              <div class="hero-icon-wrap">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16,11C16,9.89 15.1,9 14,9H12V7H16V5H12V3H10V5H8V7H10V9H8C6.9,9 6,9.89 6,11V15C6,16.11 6.9,17 8,17H10V19H6V21H10V23H12V21H16V19H12V17H14C15.1,17 16,16.11 16,15V11M14,15H8V11H14V15Z"/>
                </svg>
              </div>
              <div>
                <h1 class="hero-title">Active Subscriptions</h1>
                <p class="hero-subtitle">Paying users and their WhatsApp Connect session status</p>
              </div>
            </div>
            <button class="btn-refresh" @click="loadData" :disabled="loading">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" :class="{ spinning: loading }">
                <path d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"/>
              </svg>
              Refresh
            </button>
          </div>

          <!-- Stat Cards -->
          <div v-if="!loading && !error" class="stat-cards">
            <div class="stat-card stat-card--blue">
              <div class="stat-card-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z"/>
                </svg>
              </div>
              <div class="stat-card-body">
                <div class="stat-val">{{ subscribers.length }}</div>
                <div class="stat-lbl">Total Subscribers</div>
              </div>
            </div>
            <div class="stat-card stat-card--green">
              <div class="stat-card-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,16.5L6.5,12L7.91,10.59L11,13.67L16.09,8.58L17.5,10L11,16.5Z"/>
                </svg>
              </div>
              <div class="stat-card-body">
                <div class="stat-val">{{ sessionActiveCount }}</div>
                <div class="stat-lbl">Session Active</div>
              </div>
            </div>
            <div class="stat-card stat-card--orange">
              <div class="stat-card-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M13,14H11V10H13M13,18H11V16H13M1,21L12,2L23,21H1Z"/>
                </svg>
              </div>
              <div class="stat-card-body">
                <div class="stat-val">{{ sessionInactiveCount }}</div>
                <div class="stat-lbl">Session Inactive</div>
              </div>
            </div>
            <div class="stat-card stat-card--gray">
              <div class="stat-card-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M15,16H13V11H15V16M15,9H13V7H15V9Z"/>
                </svg>
              </div>
              <div class="stat-card-body">
                <div class="stat-val">{{ noSessionCount }}</div>
                <div class="stat-lbl">No Session</div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <div v-if="!loading && !error" class="toolbar">
            <div class="search-wrap">
              <svg class="search-icon" width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
              </svg>
              <input v-model="search" type="text" class="search-input" placeholder="Search name, email or session ID…" />
            </div>
            <select v-model="sessionFilter" class="filter-select">
              <option value="all">All Sessions</option>
              <option value="active">Active Only</option>
              <option value="inactive">Inactive Only</option>
              <option value="none">No Session</option>
            </select>
            <span class="result-count">{{ filtered.length }} result{{ filtered.length !== 1 ? 's' : '' }}</span>
          </div>

          <!-- Loading -->
          <div v-if="loading" class="state-block">
            <div class="spinner"></div>
            <p>Loading active subscribers…</p>
          </div>

          <!-- Error -->
          <div v-else-if="error" class="state-block">
            <div class="state-icon state-icon--red">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M13,14H11V10H13M13,18H11V16H13M1,21L12,2L23,21H1Z"/>
              </svg>
            </div>
            <p class="state-msg">{{ error }}</p>
            <button class="btn-refresh" @click="loadData">Try Again</button>
          </div>

          <!-- Table -->
          <div v-else class="table-card">

            <div v-if="filtered.length === 0" class="state-block">
              <div class="state-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
                </svg>
              </div>
              <p class="state-msg">No subscribers match your filters.</p>
            </div>

            <table v-else class="subs-table">
              <thead>
                <tr>
                  <th class="th-num">#</th>
                  <th>User</th>
                  <th>Plan</th>
                  <th>Expires</th>
                  <th>Session ID</th>
                  <th>Status</th>
                  <th>Last Updated</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in filtered" :key="row.user_id" class="trow">
                  <td class="td-num">{{ index + 1 }}</td>

                  <td class="td-user">
                    <div class="user-cell">
                      <div class="avatar" :style="{ background: avatarColor(row.name) }">
                        {{ initials(row.name) }}
                      </div>
                      <div>
                        <div class="user-name">{{ row.name }}</div>
                        <div class="user-email">{{ row.email }}</div>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="plan-chip">
                      <span class="plan-name">{{ row.plan_name || 'Plan ' + row.plan_id }}</span>
                      <span class="plan-price">{{ row.plan_price }} EGP</span>
                    </div>
                  </td>

                  <td class="td-date">{{ formatDate(row.end_date) }}</td>

                  <td class="td-session">
                    <code v-if="row.unique_session_id" class="session-code" :title="row.unique_session_id">
                      {{ row.unique_session_id }}
                    </code>
                    <span v-else class="muted">—</span>
                  </td>

                  <td>
                    <span v-if="row.unique_session_id === null" class="status-badge status-none">
                      <span class="dot dot-gray"></span>No Session
                    </span>
                    <span v-else-if="row.session_active" class="status-badge status-active">
                      <span class="dot dot-green pulse"></span>Active
                    </span>
                    <span v-else class="status-badge status-inactive">
                      <span class="dot dot-red"></span>Inactive
                    </span>
                  </td>

                  <td class="td-date">
                    <span v-if="row.session_updated_at">{{ formatDate(row.session_updated_at) }}</span>
                    <span v-else class="muted">—</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'
import TopHeader from '@/components/TopHeader.vue'

const AVATAR_COLORS = [
  '#6366f1', '#8b5cf6', '#ec4899', '#f59e0b',
  '#10b981', '#3b82f6', '#ef4444', '#14b8a6'
]

export default {
  name: 'ActiveSubscriptionsView',
  components: { Sidebar, TopHeader },

  data () {
    return {
      loading: false,
      error: null,
      subscribers: [],
      search: '',
      sessionFilter: 'all'
    }
  },

  computed: {
    sessionActiveCount () {
      return this.subscribers.filter(r => r.unique_session_id !== null && r.session_active).length
    },
    sessionInactiveCount () {
      return this.subscribers.filter(r => r.unique_session_id !== null && !r.session_active).length
    },
    noSessionCount () {
      return this.subscribers.filter(r => r.unique_session_id === null).length
    },
    filtered () {
      let list = this.subscribers

      if (this.sessionFilter === 'active') {
        list = list.filter(r => r.unique_session_id !== null && r.session_active)
      } else if (this.sessionFilter === 'inactive') {
        list = list.filter(r => r.unique_session_id !== null && !r.session_active)
      } else if (this.sessionFilter === 'none') {
        list = list.filter(r => r.unique_session_id === null)
      }

      if (this.search.trim()) {
        const q = this.search.trim().toLowerCase()
        list = list.filter(r =>
          r.name?.toLowerCase().includes(q) ||
          r.email?.toLowerCase().includes(q) ||
          r.unique_session_id?.toLowerCase().includes(q)
        )
      }

      return list
    }
  },

  methods: {
    async loadData () {
      this.loading = true
      this.error = null
      try {
        const token = localStorage.getItem('token')
        const res = await fetch('https://api.quali-d.com/admin/whatsapp/active-subscribers', {
          headers: { Authorization: `Bearer ${token}` },
          mode: 'cors'
        })
        const json = await res.json()
        if (json.success) {
          this.subscribers = json.data
        } else {
          this.error = json.message || 'Failed to load data.'
        }
      } catch (err) {
        this.error = err.message || 'Network error.'
      } finally {
        this.loading = false
      }
    },

    initials (name) {
      if (!name) return '?'
      return name.trim().split(/\s+/).slice(0, 2).map(w => w[0].toUpperCase()).join('')
    },

    avatarColor (name) {
      if (!name) return AVATAR_COLORS[0]
      const code = name.charCodeAt(0) + (name.charCodeAt(1) || 0)
      return AVATAR_COLORS[code % AVATAR_COLORS.length]
    },

    formatDate (val) {
      if (!val) return '—'
      const d = new Date(val)
      if (isNaN(d)) return val
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    }
  },

  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>
/* ── Layout ─────────────────────────────────────────────── */
.active-subs-layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: var(--bg-primary);
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.page-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}
.active-subs-view {
  max-width: 1260px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ── Hero ───────────────────────────────────────────────── */
.hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  border-radius: 14px;
  padding: 20px 24px;
  color: #fff;
}
.hero-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.hero-icon-wrap {
  width: 44px;
  height: 44px;
  background: rgba(255,255,255,0.18);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.hero-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 3px;
  color: #fff;
}
.hero-subtitle {
  font-size: 13px;
  margin: 0;
  color: rgba(255,255,255,0.75);
}
.btn-refresh {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.btn-refresh:hover:not(:disabled) { background: rgba(255,255,255,0.25); }
.btn-refresh:disabled { opacity: 0.5; cursor: not-allowed; }
@keyframes spin { to { transform: rotate(360deg); } }
.spinning { animation: spin 0.8s linear infinite; }

/* ── Stat Cards ─────────────────────────────────────────── */
.stat-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
.stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 12px;
  border: 1px solid transparent;
}
.stat-card-icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0.9;
}
.stat-val {
  font-size: 26px;
  font-weight: 800;
  line-height: 1;
}
.stat-lbl {
  font-size: 11px;
  font-weight: 600;
  margin-top: 4px;
  opacity: 0.75;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.stat-card--blue   { background: #eff6ff; border-color: #bfdbfe; color: #1d4ed8; }
.stat-card--blue   .stat-card-icon { background: #dbeafe; }
.stat-card--green  { background: #f0fdf4; border-color: #bbf7d0; color: #15803d; }
.stat-card--green  .stat-card-icon { background: #dcfce7; }
.stat-card--orange { background: #fff7ed; border-color: #fed7aa; color: #c2410c; }
.stat-card--orange .stat-card-icon { background: #ffedd5; }
.stat-card--gray   { background: var(--bg-secondary); border-color: var(--border-primary); color: var(--text-secondary); }
.stat-card--gray   .stat-card-icon { background: var(--bg-primary); }

/* ── Toolbar ─────────────────────────────────────────────── */
.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
}
.search-wrap {
  position: relative;
  flex: 1;
  max-width: 380px;
}
.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
  pointer-events: none;
}
.search-input {
  width: 100%;
  padding: 9px 12px 9px 34px;
  border: 1px solid var(--border-primary);
  border-radius: 9px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  box-sizing: border-box;
}
.search-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99,102,241,0.12);
}
.filter-select {
  padding: 9px 12px;
  border: 1px solid var(--border-primary);
  border-radius: 9px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 13px;
  cursor: pointer;
  outline: none;
}
.result-count {
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
  margin-left: 4px;
}

/* ── Table Card ──────────────────────────────────────────── */
.table-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.subs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.subs-table thead tr {
  background: var(--bg-primary);
  border-bottom: 2px solid var(--border-primary);
}
.subs-table thead th {
  padding: 12px 16px;
  text-align: left;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
  white-space: nowrap;
}
.th-num { width: 44px; }
.trow {
  border-bottom: 1px solid var(--border-primary);
  transition: background 0.1s;
}
.trow:last-child { border-bottom: none; }
.trow:hover { background: var(--bg-primary); }
.subs-table td {
  padding: 13px 16px;
  color: var(--text-primary);
  vertical-align: middle;
}
.td-num {
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

/* User cell */
.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
  letter-spacing: 0.03em;
}
.user-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
}
.user-email {
  font-size: 11.5px;
  color: var(--text-secondary);
  margin-top: 1px;
}

/* Plan chip */
.plan-chip {
  display: inline-flex;
  align-items: center;
  gap: 0;
  background: #ede9fe;
  border: 1px solid #ddd6fe;
  border-radius: 20px;
  overflow: hidden;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}
.plan-name {
  padding: 3px 9px;
  color: #6d28d9;
}
.plan-price {
  padding: 3px 8px;
  background: #6d28d9;
  color: #fff;
  border-radius: 0 20px 20px 0;
}

/* Session ID */
.td-session { max-width: 180px; }
.session-code {
  font-family: monospace;
  font-size: 11px;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  padding: 3px 7px;
  border-radius: 5px;
  color: var(--text-secondary);
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Date */
.td-date {
  white-space: nowrap;
  font-size: 12px;
  color: var(--text-secondary);
}

/* Status badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 11px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.status-active   { background: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0; }
.status-inactive { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }
.status-none     { background: var(--bg-primary); color: var(--text-secondary); border: 1px solid var(--border-primary); }

/* Dots */
.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.dot-green { background: #22c55e; }
.dot-red   { background: #ef4444; }
.dot-gray  { background: #9ca3af; }
@keyframes pulse-anim {
  0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.5); }
  50%       { box-shadow: 0 0 0 4px rgba(34,197,94,0); }
}
.pulse { animation: pulse-anim 1.8s ease-in-out infinite; }

.muted { color: var(--text-secondary); }

/* ── States ──────────────────────────────────────────────── */
.state-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 64px 24px;
  color: var(--text-secondary);
  font-size: 14px;
}
.state-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}
.state-icon--red { background: #fef2f2; border-color: #fecaca; color: #b91c1c; }
.state-msg { margin: 0; font-size: 14px; }
.spinner {
  width: 34px;
  height: 34px;
  border: 3px solid var(--border-primary);
  border-top-color: #6366f1;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

/* ── Responsive ──────────────────────────────────────────── */
@media (max-width: 900px) {
  .stat-cards { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 600px) {
  .stat-cards { grid-template-columns: 1fr 1fr; }
  .hero { flex-direction: column; align-items: flex-start; }
}
</style>
